import _ from 'lodash';

export const getDropzoneInputPropsSelector = state =>
    _.get(state, 'uploadDocument.inputProps');

export const isUploadDocumentFetchingSelector = state =>
    _.get(state, 'uploadDocument.isFetching');
